import urlApi from '../../router/urlApi'
import { Serialize } from '../../services/serializeFormData'
import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  store () {
    let self = this

    self.disableButtons(true)

    Vue.http.post(urlApi + '/aulas/cameras', Serialize.toObject('form_cam')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarCameras()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      console.log(response)
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  update (idCam) {
    let self = this
    self.disableButtons(true)
    Vue.http.patch(urlApi + '/aulas/cameras/' + idCam, Serialize.toObject('form_cam')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarCameras()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  getCamById: function (idCam, callback) {
    Vue.http.get(urlApi + '/aulas/cameras/' + idCam).then(function (response) {
      callback(response)
    })
  },

  pageListarCameras () {
    router.push({ name: 'listagem-cameras' })
  },

  paginaEdicao (idCam) {
    router.push({ name: 'editar-camera', params: { idCam: idCam } })
  },

  getSalas (callback) {
    Vue.http.get(urlApi + '/aulas/salas').then((response) => {
      callback(response.data)
    })
  },

  carregaFormularioDeEdicao (idContato) {
    Vue.http.get(urlApi + '/aulas/cameras/' + idContato).then((response) => {
      LoadFormData.byIdInputs(response.data.dados)
    })
  },

  disableButtons (status) {
    document.getElementById('btn_salvar').disabled = status
    document.getElementById('btn_limpar').disabled = status
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  }

}
